import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { ITToolRequestService } from "../../../../../services/it-tools-request/itToolRequest.service";

interface IVariable {
  id: string;
  body: any;
}

export const useUpdateDFS = () => {
  const queryClient = useQueryClient();
  const { mutate, ...restMutation } = useMutation({
    mutationFn: ({ id, body }: IVariable) => ITToolRequestService.updateITToolRequest(id, body),
  });

  const updateDFSRequest = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["demand-for-supplies-requests"],
        });
        notification.success({
          message: "Thành công!",
          description: options?.successText ?? `Duyệt yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Duyệt yêu cầu thất bại.`,
        });
      },
    });
  };
  return { mutate, updateDFSRequest, ...restMutation };
};
